module.exports = __webpack_public_path__ + "img/Group 28173@2x.7a91a9e6.png";